<template>
    <div>
        <v-dialog v-model="visible" max-width="500">
            <v-card>
                <v-card-title class="headline">{{title}}</v-card-title>
                <v-card-text><span v-if="message" v-html="message"></span><span v-else>{{$t('Are you sure, you want delete this element?')}}</span></v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark v-if="isVisible('cancel')" :color="getColor('cancel')" @click="$emit('cancel')">{{getText('cancel')}}</v-btn>
                    <v-btn dark :color="getColor('accept')" @click="$emit('confirm')">{{getText('accept')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        props: ['title', 'message', 'buttons'],
        data(){
            return{
                visible: false,
            }
        },
        mounted() {
            this.visible = true;
        },
        methods:{
            isVisible(type){
                if(this.buttons && this.buttons[type] && typeof this.buttons[type].visible != 'undefined'){
                    return this.buttons[type].visible
                }
                return true;
            },
            getColor(type){
                if(this.buttons && this.buttons[type]){
                    return this.buttons[type].color;
                }else{
                    if(type == 'cancel') return 'grey';
                    if(type == 'accept') return 'red';
                }
            },
            getText(type){
                if(this.buttons && this.buttons[type]){
                    return this.buttons[type].text;
                }else{
                    if(type == 'cancel') return 'No';
                    if(type == 'accept') return 'Yes';
                }
            }
        }
    }
</script>
